var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1102 20H4.8898C3.43565 20 2.52917 18.4289 3.25624 17.1777L10.3664 4.93841C11.0935 3.6872 12.9065 3.6872 13.6336 4.93841L20.7438 17.1777C21.4708 18.4289 20.5644 20 19.1102 20Z",
    fill: "#F5B700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.048 10.582C11.048 10.0556 11.4738 9.62888 11.9991 9.62888C12.5244 9.62888 12.9502 10.0556 12.9502 10.582V12.4835C12.9502 13.0099 12.5244 13.4366 11.9991 13.4366C11.4738 13.4366 11.048 13.0099 11.048 12.4835V10.582Z",
    fill: "#4B4D4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0554 15.2992H12.9439V17.1807H11.0554V15.2992Z",
    fill: "#4B4D4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93457 4.6875C10.8544 3.10457 13.1456 3.10457 14.0654 4.6875L21.1758 16.9268C22.0978 18.5136 20.9472 20.4999 19.1104 20.5H4.88965C3.05277 20.4999 1.9022 18.5136 2.82422 16.9268L9.93457 4.6875Z",
    stroke: "#4B4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMessageIcon);
export default __webpack_public_path__ + "static/media/alert-message-icon.f8d8d2e67498a5bf09ea7cc581330062.svg";
export { ForwardRef as ReactComponent };